import * as VendorReducer from '../Vendor.reducer';
import { waitForVendor } from '../Vendor.saga';
var VENDOR = 'optimizely';
export var isAvailable = function isAvailable(state) {
  return VendorReducer.isAvailable(state, VENDOR);
};
export var setAvailable = VendorReducer.setAvailable.bind(null, VENDOR);
export var setLoading = VendorReducer.setLoading.bind(null, VENDOR);
export var waitForOptimizely = waitForVendor.bind(null, VENDOR);